import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { leadService } from "../../services/leads";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

const columns = [
  "new",
  "contacted",
  "interested",
  "proposal_sent",
  "converted",
  "lost",
];

const LeadKanban = ({ filters }) => {
  const queryClient = useQueryClient();
  const { data: leads } = useQuery({
    queryKey: ["leads"],
    queryFn: leadService.getAll,
  });
  const updateLeadMutation = useMutation({
    mutationFn: ({ id, data }) => leadService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(["leads"]);
      toast.success("Lead status updated");
    },
  });

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const leadId = result.draggableId;
    const newStatus = result.destination.droppableId;
    updateLeadMutation.mutate({ id: leadId, data: { status: newStatus } });
  };

  const filteredLeads = leads?.filter((lead) => {
    if (filters?.source && !lead.source?.toLowerCase().includes(filters.source.toLowerCase())) return false;
    return true;
  });

  const getLeadsByStatus = (status) =>
    filteredLeads?.filter((lead) => lead.status === status) || [];

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="flex space-x-4 overflow-x-auto p-4">
        {columns.map((status) => (
          <div key={status} className="w-80 bg-gray-100 rounded p-3">
            <h3 className="font-medium capitalize mb-2">{status}</h3>
            <Droppable droppableId={status}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="min-h-[200px]"
                >
                  {getLeadsByStatus(status).map((lead, index) => (
                    <Draggable
                      key={lead._id}
                      draggableId={lead._id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="bg-white p-3 mb-2 rounded shadow"
                        >
                          <p className="font-medium">{lead.name}</p>
                          <p className="text-sm text-gray-500">{lead.phone}</p>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        ))}
      </div>
    </DragDropContext>
  );
};

export default LeadKanban;
